import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useCalculatorStore } from '@/stores/calculator/calculatorStore'

export const useCalculatorMoneyInField = () => {
  const { moneyIn } = storeToRefs(useCalculatorStore())

  const moneyInField = computed(() => (moneyIn.value === null ? '' : String(moneyIn.value)))

  const setMoneyInField = (value: string | number) => {
    const normalized = String(value ?? '').trim()

    if (normalized === '') {
      moneyIn.value = null
      return
    }

    const parsed = Number.parseFloat(normalized)

    if (!Number.isFinite(parsed)) {
      return
    }

    moneyIn.value = parsed >= 0 ? parsed : 0
  }

  return { moneyInField, setMoneyInField }
}
